import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../../services/auth.service';
import { EnvService } from '../../../services/env.service';
import { CommonService } from '../../../services/common.service';

@Component({
	selector: 'app-mbmod',
	templateUrl: './mbmod.component.html',
	styleUrls: ['./mbmod.component.css']
})
export class MbmodComponent implements OnInit {

	frm : FormGroup;

	logi_user:any;
	mbData:any = [];

	passData:any = [];

	idx:any = "";

	vchk:any = false;

	constructor(
		private http: HttpClient,
		private router: Router,
		public dialog: MatDialog,
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public getData,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {

		this.frm = fb.group({
			mbname: ['', [Validators.required]],
			mbphone: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(11)]],
			mbdong: ['', [Validators.required]],
			mbpwd: [''],
			mbpwd_chk: [''],
			price_open: ['0'],
			price_atxt: ['0'],
			history_cfg: ['0'],
			mileage_open: ['0'],
			latest_addr: ['0'],
			rider_open: ['0'],
			contract_open: ['0'],
		}, {
			validator: ConfirmedValidator('mbpwd', 'mbpwd_chk')
		});

	}


	ngOnInit() {
		if( this.getData['idx'] == null || this.getData['idx'] == "undefined" ){ this.idx = ""; }
		else{ this.idx = this.getData['idx']; }

		if( this.getData['idx'] )
		{
			this.getMemberData(this.getData['idx']);
		}
	}

	validatorChk() {
		if( !this.vchk )
		{
			this.vchk = true;
			this.frm.controls['mbpwd'].setValidators([Validators.required, Validators.minLength(10), Validators.maxLength(10)]);
		}

		if( this.frm.get('mbpwd').value.length == 0 )
		{
			this.vchk = false;
			this.frm.controls['mbpwd'].clearValidators();
			this.frm.controls['mbpwd'].updateValueAndValidity();
		}
	}

	async getMemberData(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/member.data.php', formData).subscribe((response) => {
			if( response['data'] )
			{
				this.mbData = response['data'];

				this.frm.get('mbname').setValue( response['data']['name'] );
				this.frm.get('mbphone').setValue( response['data']['phone'] );
				this.frm.get('mbdong').setValue( response['data']['dong'] );
				this.frm.get('price_atxt').setValue( response['data']['price'] );
				this.frm.get('history_cfg').setValue( response['data']['history'] );
				this.frm.get('mileage_open').setValue( response['data']['mileage'] );
				this.frm.get('latest_addr').setValue( response['data']['latest'] );
				this.frm.get('rider_open').setValue( response['data']['rider'] );
				this.frm.get('contract_open').setValue( response['data']['contract'] );
			}
		});
	}

	async regForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		formData.append("idx", this.idx);
		formData.append("name", this.frm.get('mbname').value);
		formData.append("phone", this.frm.get('mbphone').value);
		formData.append("dong", this.frm.get('mbdong').value);
		formData.append("pwd", this.frm.get('mbpwd').value);
		formData.append("price", this.frm.get('price_atxt').value);
		formData.append("history", this.frm.get('history_cfg').value);
		formData.append("mileage", this.frm.get('mileage_open').value);
		formData.append("latest", this.frm.get('latest_addr').value);
		formData.append("rider", this.frm.get('rider_open').value);
		formData.append("contract", this.frm.get('contract_open').value);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/member.process.php', formData).subscribe((response) => {
			this.func.closeLoading();
			this.closeWrite();
			this.passData['refresh'] = "1";

			this.dialogRef.close({
				event: 'close',
				data: this.passData
			});

		});
	}

	resetForm() {
		this.frm.reset();
		this.frm.get('price_atxt').setValue("0");
		this.frm.get('history_cfg').setValue("0");
		this.frm.get('mileage_open').setValue("0");
		this.frm.get('latest_addr').setValue("0");
		this.frm.get('rider_open').setValue("0");
		this.frm.get('contract_open').setValue("0");
	}

	async closeWrite() {
		this.dialogRef.close();
	}
}

export function ConfirmedValidator(controlName: string, matchingControlName: string){
	return (formGroup: FormGroup) => {
		const control = formGroup.controls[controlName];
		const matchingControl = formGroup.controls[matchingControlName];
		if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
			return;
		}
		if (control.value !== matchingControl.value) {
			matchingControl.setErrors({ confirmedValidator: true });
		} else {
			matchingControl.setErrors(null);
		}
	}
}